// extracted by mini-css-extract-plugin
export default {"closeButton":"tour__closeButton__gHKRr","nextButton":"tour__nextButton__J24F1","popupContainer":"tour__popupContainer__KiTvq"};